import { ResourcePath } from '@api/gql/graphql';

export function toInitials(words: string[]) {
  return words.map((word) => word.charAt(0)).join('');
}

export function buildResourcePath(resourcePath: ResourcePath[]) {
  const logicalPath: string[] = [];
  const literalPath: string[] = [];
  resourcePath.map((path) => {
    logicalPath.push(path.keyDisplayName);
    if (typeof path.value === 'string') literalPath.push(path.value);
  });
  literalPath.pop();
  logicalPath.pop();

  return {
    literalPath: literalPath.join('/'),
    logicalPath: logicalPath.join('/'),
  };
}
